/*
  Sirdal Select: Booking-veiviser.

  Sju steg. Innsending går via Shopifys kontaktskjema (/contact), som sender
  e-post til butikkens kontaktadresse. Kunden får ingenting fra Shopify.

  Et valgfritt endepunkt kan settes i temaeditoren. Da varsles dere også om
  de som fyller ut steg 1 men aldri fullfører.
*/
(function () {
  'use strict';

  var SISTE_STEG = 7;

  function init(rot) {
    if (rot.dataset.bvKlar === '1') return;
    rot.dataset.bvKlar = '1';

    var cfgEl = rot.querySelector('[data-bv-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }

    var steg = rot.querySelectorAll('[data-bv-step]');
    var bar = rot.querySelector('[data-bv-bar]');
    var tittel = rot.querySelector('[data-bv-title]');
    var undertittel = rot.querySelector('[data-bv-sub]');
    var kropp = rot.querySelector('[data-bv-body]');
    var foten = rot.querySelector('[data-bv-foot]');
    var teller = rot.querySelector('[data-bv-count]');
    var tilbakeKnapp = rot.querySelector('[data-bv-back]');
    var nesteKnapp = rot.querySelector('[data-bv-next]');
    var kvittering = rot.querySelector('[data-bv-done]');
    var skjema = document.getElementById('bv-skjema');

    var naa = 1;
    var steg1Fylt = false;
    var paabegyntSendt = false;
    var ferdigSendt = false;

    /* ---------- felt og valg ---------- */

    function felt(navn) { return rot.querySelector('[name="' + navn + '"]'); }
    function verdi(navn) {
      var f = felt(navn);
      return f ? f.value.trim() : '';
    }

    /* Returnerer navnene på valgte kort. Er et tilvalg huket av,
       henges det på i parentes: «3-retters meny (med vinpakke)». */
    function valgteI(gruppe) {
      var boks = rot.querySelector('[data-bv-group="' + gruppe + '"]');
      if (!boks) return [];
      return Array.prototype.map.call(
        boks.querySelectorAll('[data-bv-item].is-valgt'),
        function (k) {
          var navn = k.dataset.bvChoice;
          var tillegg = k.querySelector('[data-bv-addon]');
          if (tillegg && tillegg.checked) navn += ' (' + tillegg.value + ')';
          return navn;
        }
      );
    }

    /* ---------- validering ---------- */

    function visFeil(navn, vis) {
      var f = felt(navn);
      var boks = rot.querySelector('[data-bv-err-for="' + navn + '"]');
      if (f) f.setAttribute('aria-invalid', vis ? 'true' : 'false');
      if (boks) boks.classList.toggle('is-shown', vis);
    }

    function gyldigEpost(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

    function sjekkSteg(n) {
      var feil = [];

      if (n === 1) {
        if (!verdi('pax') || Number(verdi('pax')) < 1) feil.push('pax');
        if (!verdi('telefon')) feil.push('telefon');
        if (!gyldigEpost(verdi('epost'))) feil.push('epost');
        if (!verdi('kontaktperson')) feil.push('kontaktperson');
        if (!verdi('fra_dato')) feil.push('fra_dato');
        if (!verdi('til_dato') || verdi('til_dato') <= verdi('fra_dato')) feil.push('til_dato');

        ['pax', 'telefon', 'epost', 'kontaktperson', 'fra_dato', 'til_dato'].forEach(function (navn) {
          visFeil(navn, feil.indexOf(navn) !== -1);
        });
      }

      if (n === 6) {
        if (!verdi('bedrift')) feil.push('bedrift');
        visFeil('bedrift', feil.indexOf('bedrift') !== -1);
      }

      if (n === SISTE_STEG) {
        var boks = felt('vilkar');
        var ok = boks && boks.checked;
        if (!ok) feil.push('vilkar');
        var melding = rot.querySelector('[data-bv-err-for="vilkar"]');
        if (melding) melding.classList.toggle('is-shown', !ok);
      }

      if (feil.length) {
        var forste = rot.querySelector('[name="' + feil[0] + '"]');
        if (forste && forste.focus) forste.focus();
        return false;
      }
      return true;
    }

    /* ---------- netter ---------- */

    function oppdaterNetter() {
      var boks = rot.querySelector('[data-bv-nights]');
      if (!boks) return;
      var fra = verdi('fra_dato');
      var til = verdi('til_dato');
      if (!fra || !til || til <= fra) { boks.textContent = ''; return; }
      var ms = new Date(til) - new Date(fra);
      var netter = Math.round(ms / 86400000);
      boks.textContent = netter === 1 ? '1 natt' : netter + ' netter';
    }

    /* ---------- oppsummering ---------- */

    function linje(navn, tekst) {
      if (!tekst) return '';
      var d = document.createElement('div');
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = navn;
      dd.textContent = tekst;
      d.appendChild(dt);
      d.appendChild(dd);
      return d.outerHTML;
    }

    function byggOppsummering() {
      var maal = rot.querySelector('[data-bv-summary]');
      if (!maal) return;

      var netter = rot.querySelector('[data-bv-nights]');
      var datoer = verdi('fra_dato') + ' – ' + verdi('til_dato');
      if (netter && netter.textContent) datoer += ' (' + netter.textContent + ')';

      var html = '';
      html += linje('Kontakt', verdi('kontaktperson'));
      html += linje('E-post', verdi('epost'));
      html += linje('Telefon', verdi('telefon'));
      html += linje('Antall', verdi('pax') + ' personer');
      html += linje('Datoer', datoer);
      html += linje('Overnatting', valgteI('overnatting').join(', '));
      html += linje('Møterom', valgteI('moterom').join(', '));
      html += linje('Deltakere i møtet', verdi('deltakere'));
      html += linje('Utstyr', verdi('utstyr'));
      html += linje('Mat', valgteI('mat').join(', '));
      html += linje('Allergier', verdi('allergier'));
      html += linje('Aktiviteter', valgteI('aktivitet').join(', '));
      html += linje('Bedrift', verdi('bedrift'));
      html += linje('Org.nr', verdi('orgnr'));
      html += linje('Fakturaadresse', verdi('fakturaadresse'));
      html += linje('Faktura-e-post', verdi('faktura_epost'));
      html += linje('Kommentar', verdi('kommentar'));

      maal.innerHTML = html;
    }

    /* ---------- navigasjon ---------- */

    function visSteg(n) {
      naa = n;

      Array.prototype.forEach.call(steg, function (s) {
        s.classList.toggle('is-active', Number(s.dataset.bvStep) === n);
      });

      Array.prototype.forEach.call(bar.children, function (b, i) {
        b.classList.toggle('is-done', i < n);
      });
      bar.setAttribute('aria-valuenow', String(n));

      var t = (cfg.titles && cfg.titles[String(n)]) || '';
      if (tittel && t) tittel.textContent = t;
      if (undertittel) undertittel.hidden = n !== 1;

      if (teller) teller.textContent = 'Steg ' + n + ' av ' + SISTE_STEG;
      tilbakeKnapp.hidden = n === 1;
      nesteKnapp.textContent = n === SISTE_STEG ? (cfg.sendLabel || 'Send forespørsel') : (cfg.nextLabel || 'Neste');

      if (n === SISTE_STEG) byggOppsummering();
      if (kropp) kropp.scrollTop = 0;
    }

    function neste() {
      if (!sjekkSteg(naa)) return;
      if (naa === 1 && !steg1Fylt) { steg1Fylt = true; startKlokke(); }
      if (naa === SISTE_STEG) { sendInn(); return; }
      visSteg(naa + 1);
    }

    function tilbake() { if (naa > 1) visSteg(naa - 1); }

    /* ---------- innsending ---------- */

    function samle() {
      return {
        kontaktperson: verdi('kontaktperson'),
        epost: verdi('epost'),
        telefon: verdi('telefon'),
        personer: verdi('pax'),
        fra: verdi('fra_dato'),
        til: verdi('til_dato'),
        overnatting: valgteI('overnatting'),
        moterom: valgteI('moterom'),
        deltakere: verdi('deltakere'),
        utstyr: verdi('utstyr'),
        mat: valgteI('mat'),
        allergier: verdi('allergier'),
        aktiviteter: valgteI('aktivitet'),
        bedrift: verdi('bedrift'),
        orgnr: verdi('orgnr'),
        fakturaadresse: verdi('fakturaadresse'),
        faktura_epost: verdi('faktura_epost'),
        kommentar: verdi('kommentar')
      };
    }

    /* Fyller det skjulte kontaktskjemaet. Samme vei som en vanlig
       henvendelse, så e-posten lander der dere allerede leser. */
    function fyllSkjema(d, paabegynt) {
      var hvem = d.kontaktperson + (d.bedrift ? ' — ' + d.bedrift : '');
      skjema.querySelector('[data-bv-fb-email]').value = d.epost;
      skjema.querySelector('[data-bv-fb-tlf]').value = d.telefon;
      skjema.querySelector('[data-bv-fb-navn]').value =
        (paabegynt ? 'PÅBEGYNT — ' : '') + hvem;
      skjema.querySelector('[data-bv-fb-body]').value = somTekst(d, paabegynt);
    }

    /* Gjesten fylte ut steg 1 og forlot siden uten å fullføre.
       Sendes med sendBeacon, som overlever at fanen lukkes.

       Bevisst bare på pagehide: visibilitychange ville også slått til
       når noen bytter fane for å slå opp en dato, og gitt falske varsler. */
    function sendPaabegynt(maate) {
      if (paabegyntSendt || ferdigSendt || !steg1Fylt) return;
      paabegyntSendt = true;

      var d = samle();

      if (cfg.leadEndpoint) {
        var last = JSON.stringify({ type: 'paabegynt', butikk: cfg.shop, data: d });
        if (maate === 'beacon' && navigator.sendBeacon) {
          navigator.sendBeacon(cfg.leadEndpoint, new Blob([last], { type: 'application/json' }));
        } else {
          fetch(cfg.leadEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: last
          }).catch(function () {});
        }
        return;
      }

      fyllSkjema(d, true);
      var pakke = new FormData(skjema);

      if (maate === 'beacon') {
        if (navigator.sendBeacon) navigator.sendBeacon(skjema.action, pakke);
      } else {
        /* Siden lever ennå, så vi kan sende på vanlig vis og få vite
           om det gikk bra. */
        fetch(skjema.action, { method: 'POST', body: pakke }).catch(function () {});
      }
    }

    /* To utløsere. Klokka er den sikre — nettleseren rekker ikke alltid
       å sende noe når fanen lukkes, særlig ikke på mobil. */
    function startKlokke() {
      var min = Number(cfg.paabegyntMin || 0);
      if (!min) return;
      window.setTimeout(function () { sendPaabegynt('fetch'); }, min * 60000);
    }

    window.addEventListener('pagehide', function () { sendPaabegynt('beacon'); });

    function somTekst(d, paabegynt) {
      var rader = [
        ['Antall personer', d.personer],
        ['Datoer', d.fra + ' til ' + d.til],
        ['Overnatting', d.overnatting.join(', ')],
        ['Møterom', d.moterom.join(', ')],
        ['Deltakere i møtet', d.deltakere],
        ['Utstyr', d.utstyr],
        ['Mat', d.mat.join(', ')],
        ['Allergier', d.allergier],
        ['Aktiviteter', d.aktiviteter.join(', ')],
        ['', ''],
        ['Bedrift', d.bedrift],
        ['Org.nr', d.orgnr],
        ['Fakturaadresse', d.fakturaadresse],
        ['Faktura-e-post', d.faktura_epost],
        ['Kontaktperson', d.kontaktperson],
        ['Telefon', d.telefon],
        ['', ''],
        ['Kommentar', d.kommentar],
        ['Vilkår', 'Godtatt ' + new Date().toLocaleString('nb-NO')]
      ];

      var linjer = rader.map(function (r) {
        if (!r[0]) return '';
        return r[1] ? r[0] + ': ' + r[1] : null;
      }).filter(function (l) { return l !== null; }).join('\n');

      if (!paabegynt) return linjer;

      return 'PÅBEGYNT FORESPØRSEL — ikke fullført\n' +
             'Gjesten fylte ut kontaktsteget og forlot siden. Ta gjerne kontakt.\n' +
             'Kom til steg ' + naa + ' av ' + SISTE_STEG + '.\n\n' + linjer;
    }

    function sendInn() {
      var d = samle();

      nesteKnapp.disabled = true;
      nesteKnapp.textContent = 'Sender …';

      /* Settes med en gang, så et sideskift midt i sendingen ikke
         utløser et «påbegynt»-varsel i tillegg. */
      ferdigSendt = true;

      fyllSkjema(d, false);

      /* Vanlig skjemainnsending, ikke fetch: butikkens spamvern legger
         captcha-koden på i submit-hendelsen, og den rekker vi bare å få
         med oss når nettleseren sender skjemaet selv.

         Siden lastes på nytt med ?contact_posted=true, og da åpner vi
         veiviseren igjen på kvitteringen. */
      if (skjema.requestSubmit) {
        skjema.requestSubmit();
      } else {
        skjema.submit();
      }
    }

    function ferdig() {
      Array.prototype.forEach.call(steg, function (s) { s.classList.remove('is-active'); });
      if (foten) foten.hidden = true;
      if (bar) {
        Array.prototype.forEach.call(bar.children, function (b) { b.classList.add('is-done'); });
      }
      if (tittel) tittel.textContent = '';
      if (undertittel) undertittel.hidden = true;
      kvittering.classList.add('is-active');
      kvittering.setAttribute('tabindex', '-1');
      kvittering.focus();
      rot.dispatchEvent(new CustomEvent('bv:sendt', { bubbles: true }));
    }

    /* ---------- vilkår ---------- */

    var vilkarPanel = rot.querySelector('[data-bv-terms]');

    function visVilkar(vis) {
      if (!vilkarPanel) return;
      vilkarPanel.hidden = !vis;
      if (vis) {
        vilkarPanel.querySelector('[data-bv-terms-close]').focus();
      } else {
        var aapner = rot.querySelector('[data-bv-terms-open]');
        if (aapner) aapner.focus();
      }
    }

    /* ---------- hendelser ---------- */

    nesteKnapp.addEventListener('click', neste);
    tilbakeKnapp.addEventListener('click', tilbake);

    function nullstill(kort) {
      kort.classList.remove('is-valgt');
      var pick = kort.querySelector('.bv-card__pick');
      if (pick) pick.setAttribute('aria-pressed', 'false');
      var tillegg = kort.querySelector('[data-bv-addon]');
      if (tillegg) tillegg.checked = false;
    }

    rot.addEventListener('click', function (e) {
      if (e.target.closest('[data-bv-terms-open]')) { visVilkar(true); return; }
      if (e.target.closest('[data-bv-terms-close]')) { visVilkar(false); return; }

      /* Tilvalget er en egen avkryssing — den skal ikke slå av kortet. */
      if (e.target.closest('.bv-card__addon')) return;

      var velg = e.target.closest('.bv-card__pick');
      if (velg) {
        var kort = velg.closest('[data-bv-item]');
        var boks = kort.closest('[data-bv-group]');
        var flere = boks && boks.dataset.bvMulti === 'true';
        var paa = kort.classList.contains('is-valgt');

        if (!flere && !paa) {
          Array.prototype.forEach.call(boks.querySelectorAll('[data-bv-item]'), nullstill);
        }
        if (paa) {
          nullstill(kort);
        } else {
          kort.classList.add('is-valgt');
          velg.setAttribute('aria-pressed', 'true');
        }
        return;
      }

      if (e.target.closest('[data-bv-skip]')) {
        var g = e.target.closest('[data-bv-group]');
        if (g) Array.prototype.forEach.call(g.querySelectorAll('[data-bv-item]'), nullstill);
        neste();
      }
    });

    rot.addEventListener('input', function (e) {
      if (e.target.name === 'fra_dato' || e.target.name === 'til_dato') oppdaterNetter();
      if (e.target.getAttribute('aria-invalid') === 'true') visFeil(e.target.name, false);
      if (e.target.name === 'vilkar') {
        var m = rot.querySelector('[data-bv-err-for="vilkar"]');
        if (m) m.classList.remove('is-shown');
      }
    });

    rot.addEventListener('keydown', function (e) {
      /* Escape lukker vilkårene først, ikke hele veiviseren. */
      if (e.key === 'Escape' && vilkarPanel && !vilkarPanel.hidden) {
        e.stopPropagation();
        visVilkar(false);
        return;
      }

      if (e.key !== 'Enter') return;
      var t = e.target;
      if (t.tagName === 'TEXTAREA' || t.closest('.bv-card')) return;
      e.preventDefault();
      neste();
    });

    /* Fra-dato kan ikke være i fortiden, og til-dato ikke før fra-dato. */
    var idag = new Date().toISOString().slice(0, 10);
    var fraFelt = felt('fra_dato');
    var tilFelt = felt('til_dato');
    if (fraFelt) {
      fraFelt.min = idag;
      fraFelt.addEventListener('change', function () {
        if (tilFelt) tilFelt.min = fraFelt.value || idag;
      });
    }
    if (tilFelt) tilFelt.min = idag;

    visSteg(1);

    /* Etter innsending sender Shopify gjesten tilbake hit med
       ?contact_posted=true. Er en takkeside satt, skal de dit i stedet —
       reserveløsning for at Shopify ikke alltid følger return_to. */
    if (window.location.search.indexOf('contact_posted=true') !== -1) {
      ferdigSendt = true;

      var takk = (cfg.takkUrl || '').trim();
      if (takk && window.location.pathname !== takk.split('?')[0]) {
        window.location.replace(takk);
        return;
      }

      ferdig();
      rot.dispatchEvent(new CustomEvent('bv:apne', { bubbles: true }));
    }
  }

  function start() {
    document.querySelectorAll('[data-bv-root]').forEach(init);
  }

  /* Modalen henter veiviseren i etterkant og kaller denne når den er inne. */
  window.bvStart = start;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Temaeditoren bygger seksjoner om på nytt. */
  document.addEventListener('shopify:section:load', start);
})();
